import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from './pipes/duration.pipe';
import { EventNamePipe } from './pipes/event-name.pipe';
import { GameScorePipe } from './pipes/game-score.pipe';
import { TiebreakScorePipe } from './pipes/tiebreak-score.pipe';
import { OrdinalPipe } from './pipes/ordinal.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { NameFormatterPipe } from './pipes/name-formatter.pipe';
import { PartnerNamePipe } from './pipes/partner-name.pipe';
import { EmailLowercaseDirective } from './directives/email-lowercase.directive';
import { DatetimeItemComponent } from './components/datetime-item/datetime-item.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule.forChild(),
    LanguageSelectorComponent,
    PartnerNamePipe
  ],
  declarations: [
    DurationPipe,
    EventNamePipe,
    GameScorePipe,
    TiebreakScorePipe,
    OrdinalPipe,
    TruncatePipe,
    NameFormatterPipe,
    EmailLowercaseDirective,
    DatetimeItemComponent
  ],
  exports: [
    DurationPipe,
    EventNamePipe,
    GameScorePipe,
    TiebreakScorePipe,
    OrdinalPipe,
    TruncatePipe,
    NameFormatterPipe,
    EmailLowercaseDirective,
    DatetimeItemComponent,
    LanguageSelectorComponent,
    PartnerNamePipe
  ],
  providers: [],
})
export class SharedModule {}
